import { useCallback, useMemo, useState } from 'react';
import { AccountStatus, CIPStatus } from '@common-fe/common-fe';

// import { useAuthStore } from '@/modules/user';
import ROUTES from '@/common/routes';
import { useHistory } from '@/modules/core/hooks';

import { useEnrollmentsData } from '../../hooks';
import { useCIPIdentificationQuery, useCIPInfoQuery } from '../queries';

interface Params {
  employeeId: string;
  accountId?: string;
}

interface FailedEnrollment {
  id: string;
  name: string;
}

const useCIPInfoVerification = ({ employeeId, accountId }: Params) => {
  const [isShowErrorModal, setShowErrorModal] = useState(false);
  const { enrollments = [] } = useEnrollmentsData(employeeId);

  const failedEnrollment = useMemo(() => {
    let list = enrollments.filter(
      (item) =>
        (item.CIPStatus === CIPStatus.Fail ||
          item.CIPStatus === CIPStatus.Question ||
          item.CIPStatus === CIPStatus.CipFailedAccountClosed) &&
        item.isCIPRequired &&
        item.accountStatus !== AccountStatus.CLOSED
    );

    if (accountId) {
      list = list.filter((item) => item.id == accountId);
    }

    const foramttedList: FailedEnrollment[] = list.map((item) => ({
      id: item.id,
      name: item.name,
    }));

    return foramttedList;
  }, [accountId, enrollments]);

  const closedEnrollmentIds = useMemo(() => {
    const list = enrollments.filter(
      (item) => item.isCIPRequired && item.accountStatus === AccountStatus.CLOSED
    );
    return list.map((item) => item.id);
  }, [enrollments]);

  const { data } = useCIPInfoQuery(employeeId);
  const [isVerificationLoading, setVerificationLoading] = useState(false);
  const { handleRefetch } = useCIPIdentificationQuery({
    enabled: false,
    employeeId,
    onError: () => {
      setShowErrorModal(true);
    },
  });
  const history = useHistory();

  const handleVerify = useCallback(async () => {
    try {
      setVerificationLoading(true);
      const { idScanUrl } = await handleRefetch();

      if (idScanUrl) {
        history.push(ROUTES.ID_SCAN(employeeId));
      } else {
        setShowErrorModal(true);
      }
    } catch {
      setShowErrorModal(true);
    } finally {
      setVerificationLoading(false);
    }
  }, [employeeId, handleRefetch, history]);

  return {
    data,
    isShowErrorModal,
    setShowErrorModal,
    handleVerify,
    isVerificationLoading,
    failedEnrollment,
    closedEnrollmentIds,
  };
};

export default useCIPInfoVerification;
